import { fromJS } from 'immutable';

import * as types from './constants';

const initState = fromJS({
  filters: {
    skip: 0,
    take: 10,
    page: 1,
    terms: '',
    type: undefined,
  },
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.UPDATE_FILTERS: {
      return state.set('filters', fromJS(payload));
    }
    default:
      return state;
  }
};
